/**
 * A bus for handling events in a type-safe manner.
 * It allows registering and emitting events with specific types.
 */
export class Bus {
    domElement = document.createElement('div');
    constructor(_schema) {
        // only for typing
    }
    /**
     * Registers a callback for a specific event.
     * @param event The event key to listen for
     * @param callback The callback to invoke when the event is emitted
     * @param signal The AbortSignal to cancel the listener
     */
    register(event, callback, signal) {
        const listener = ({ detail }) => callback(detail);
        this.domElement.addEventListener(event, listener, { signal });
    }
    /**
     * Emits an event on the bus.
     * @param event The event key to emit
     * @param params The parameters to include with the event
     */
    emit(event, ...params) {
        this.domElement.dispatchEvent(new CustomEvent(event, { detail: params[0] }));
    }
}
